<template>
  <div class="inputAibabaProd">
    <div class="container">
      <!-- Content here -->
      <br />
      <nav class="navbar navbar-light bg-light">
        <span class="navbar-brand mb-0 h1">委託代買幫訂單</span>
        <button type="button" class="btn btn-primary" @click="goToInputProd()">
          回存擋網址頁
        </button>
      </nav>

      <div v-if="displayViews != ''">
        <!-- conent -->
        <div
          v-for="(displayView, index) in displayViews"
          v-bind:key="(displayView, index)"
        >
          <div>
            <div class="list-group">
              <li
                class="mt-3 mb-3 list-group-item list-group-item-action flex-column align-items-start"
              >
                <div class="d-flex w-100 justify-content-between">
                  <small></small>
                </div>
                <p class="mb-1">訂單編號:{{ displayView.key }}</p>
                <p class="mb-1">
                  <b
                    >存擋日期:
                    {{ displayView.creat_date_dispaly.split(' ')[0] }}</b
                  >
                </p>
                <hr size="10" />
                <p class="mb-1">
                  <a :href="displayView.prod_url">阿里巴巴網址</a>
                </p>
              </li>
            </div>
          </div>
        </div>
        <!-- conent -->
        <!-- footer -->
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">總共:{{ displayViews.length }}產品</p>
          </div>
        </div>
        <!-- footer -->
      </div>
      <div v-else>
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">目前沒有任何產品</p>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="false"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
.P-logo {
  height: 100px;
  width: 100px;
}

.countdown {
  padding: 0px 10px;
}

.expiry_date {
  font-weight: bold;
}

.send_date {
  font-weight: bold;
}

.count_l1 {
  font-weight: bold;
}

.count_l2 {
  font-weight: bold;
}

.prod_detail {
  font-size: 10px;
}

.category_text {
  text-align: left;
  padding: 10px 0px;
}

.category_scrollview {
  overflow: hidden;
  width: auto;
  overflow-x: auto;
  white-space: nowrap;
}

.category_button {
  display: inline-block;
  padding: 0px 2px;
}

.card_button {
  padding: 10px 0px;
}

.card_contain {
  padding: 20px;
  width: 18rem;
}

.checkbox_size {
  zoom: 2;
  width: 20px;
  height: 20px;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'orders',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: true,
      userId: '',
      userImage: '',
      userName: '',
      categoryViews: '',
      displayViews: '',
      nowStatus: 0,
    }
  },
  watch: {},
  computed: {},
  methods: {
    queryInputProd: function () {
      const vm = this
      vm.isLoading = true
      vm.$toast.open({
        message: '查詢中!',
        type: 'success',
      })
      axios
        .post(vm.apiUrl + 'QueryInputProd', {})
        .then(function (response) {
          if (response.data.length == 0) {
            // alert("系統錯誤請稍後再試");
            vm.$toast.open({
              message: '目前沒有商品!',
              type: 'error',
            })
          } else {
            vm.displayViews = response.data
            console.log(JSON.stringify(vm.displayViews))
            vm.$toast.open({
              message: '查詢成功!',
              type: 'success',
            })
          }
          vm.isLoading = false
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          // console.log(response.data);
        })
        .catch(function (error) {
          alert(error)
          // console.log(error);
          vm.isLoading = false
        })
    },
    goToInputProd: function () {
      const vm = this
      vm.$router.push('inputalibabaorder')
    },
  },
  mounted() {
    const vm = this
    vm.isLoading = false
    vm.queryInputProd()
  },
}
</script>
